import { jsx as o } from "@emotion/react/jsx-runtime";
import { memo as e } from "react";
import { Text as m } from "@partoohub/ui";
const t = e(({
  title: r
}) => typeof r == "string" ? /* @__PURE__ */ o(m, { variant: "heading3", as: "span", color: "default", children: r }) : r);
t.displayName = "Title";
export {
  t as Title
};
